module.exports = __webpack_public_path__ + "static/img/zuosousuo.708e1f64.svg";